module.exports = __webpack_public_path__ + "img/05.ff9f6ace.png";